// extracted by mini-css-extract-plugin
module.exports = {"markdownContainer":"Markdown_markdownContainer__PreVM"};